import { defineMessages } from 'react-intl'

const messages = defineMessages({
  locale: 'en',
  app_name: 'CS Orthoseminars ADRIA',
  sign_in: 'Sign in',
  sign_out: 'Sign out',
  username: 'Username',
  password: 'Password',
  about: 'About',
  home: 'Home',
  page_not_found: 'Page not found',
  settings: 'Settings',
  theme: 'Theme',
  default: 'Default',
  red: 'Red',
  green: 'Green',
  language: 'Language',
  en: 'English',
  hr: 'Croatian',
  de: 'German',
  ru: 'Russian',
  menu: 'Menu',
  menu_mini_mode: 'Mini menu',
  offline: 'Offline',
  helmet_description: 'CS Orthoseminars ADRIA - Seminars for all dentists in 9 modules!',
  helmet_keywords: 'orthodontic seminars, seminars, seminars for dentists, seminars for doctor of dental medicine, seminars for dentistry, csorthoseminars, adria seminars, education, orthodontics, csorthoseminars adria, dentistry, dentist, dentist, surgery, maxillofacial, maxillofacial lock, spe curve, dental, specialization, dental practice, cso-adria, cso, common sense, croatian chamber of dental medicine, hkdm ',



// ############ MENU SEKCIJA #######################
  menu_home: 'Home',
  menu_back: 'Back',
  menu_seminar_content: 'Seminar content',
  menu_register: 'Registration',  
  menu_instructor: 'Instructor',
  menu_FAQ: 'FAQ',
  menu_team: 'Team',
  menu_testimonial: 'Testimonials',
  free_entrance: 'Free of charge',
  modules9_days19: '9 Modules / 19 Day',
  module_1: 'Module 1',
  module_2: 'Module 2',
  module_3: 'Module 3',
  module_4: 'Module 4',
  module_5: 'Module 5',
  module_6: 'Module 6',
  module_7: 'Module 7',
  module_8: 'Module 8',
  module_9: 'Module 9',

  discount_early_registration_sarajevo_series_2: 'Discount for applications until March 6, 2023',
  discount_early_registration_sarajevo_series_2_details: '800 KM discount for applications until March 6, 2023',

  footer_menu_terms_and_conditions: 'Terms of Use',
  footer_menu_privacy: 'Privacy Policy',
  footer_menu_impressum: 'Legal Notice',

  terms_and_use_title: 'Terms of Use',
  privacy_policy_title: 'Privacy Policy',

  // ############ COURSE CONTENT SECTION #######################
  
  course_content_title: 'When joining our seminar Course, you get access to a wealth of materials',
  course_content_subtitle: 'Our offer',
  course_content_600: 'Documented cases',
  course_content_40000: 'Information page',
  course_content_25: 'Animations',
  course_content_50: 'Video visualisation',

  //################# SEMINAR DATE ###################################

  date_seminar_intro_sarajevo_2022: '07 May 2022 1600 - 1900 hours',
  date_seminar_intro_zagreb_2022: '10 September 2022 1600 - 1900 hours',
  date_seminar_series_sarajevo_1: '27 May 2022 - 08 Jul 2023',
  date_seminar_series_zagreb_5: '07 October 2022 - 27 October 2023',

  discount_early_registration_sarajevo_series_1: '-', //'800 KM discount for registration until 10.05.22',
  discount_early_registration_zagreb_series_5: '-', //'3000 KN discount until 24.07.2022',
  discount_early_registration_zagreb_series_6: '400 € discount for early sign up until 24.09.2023', //'3000 KN discount until 24.07.2022',

  //################ SEMINAR AND HOTEL NAME #####################################

  name_intro_seminar: 'Free INTRO Seminar',  
  series_name: 'Seminar series - Sarajevo',

  seminar_name_sarajevo_intro: 'Intro seminar - Sarajevo',
  seminar_description_sarajevo_intro: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosnia and Herzegovina',

  seminar_name_sarajevo_serie_1: '1. Series of seminars - Sarajevo',
  seminar_description_sarajevo_serie_1: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosnia and Herzegovina',

  seminar_name_sarajevo_serie_2: '2nd Series of seminars - Sarajevo',
  seminar_description_sarajevo_serie_2: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosnia and Herzegovina',

  seminar_name_zagreb_intro: 'Intro seminar - Zagreb',
  seminar_description_zagreb_intro: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Croatia',

  seminar_name_zagreb_serie_5: '5th Series of seminars - Zagreb',
  seminar_description_zagreb_series_5: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Croatia',

  seminar_name_zagreb_serie_6: '6th Series of seminars - Zagreb',
  seminar_description_zagreb_series_6: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Croatia',

  seminar_name_sarajevo_intro_2024: 'Intro seminar - Sarajevo',
  seminar_description_sarajevo_intro_2024: 'Edukacijski centar Stomatološke komore FBiH, Antuna Hangija do br. 3 71000 Sarajevo, BiH',

  //################ INTRO SEMINAR ####################################

  content_intro_1: 'Free Intro seminar',
  content_intro_2: 'Food and drink',
  content_intro_3: 'Dynamic atmosphere',
  content_intro_4: 'Case studies',
  content_intro_5: 'Your first orthodontic steps',
  content_button: 'Sign in',
  waiting_list: 'Waiting list',
  sold_out: 'SOLD OUT',
  info_prices: 'Info & Prices',
  only_info: 'Info',

  //############## SEMINAR SERIES ################################

  content_series_1:'9 Modules / 19 days',
  content_series_2:'Food and drink',
  content_series_3:'Dynamic atmosphere',
  content_series_4:'Examples from practice',
  content_series_5:'Working materials and scripts',
  content_rs_komora_info: 'Chamber of Dr. Stom. Republika Srpska awards 54 points to its members',

  // ############### BENEFITS SECTION #########################
  
  benefits_title: 'Benefits of our seminar series',
  benefits_subtitle: 'The positive impact of our seminars on...',
  benefits_doctor: '...your office',
  benefits_patient: '...your patients',
  benefit_ord_1: 'Improve the quality of your work, and offer a wider range of treatments',
  benefit_ord_2: 'During our seminar series, you will acquire a high level of orthodontic knowledge, which will enable you to successfully perform orthodontic treatments in your office',
  benefit_ord_3: 'We share the insights that we have gained during decades of work in the field of orthodontics.',
  benefit_ord_4: 'We show you the outcomes of successful treatments, but we also show what can go wrong, and how to avoid failures in your practice',
  benefit_ord_5: 'We will provide study materials and instruments necessary to equip your office for orthodontics',
  benefit_ord_6: 'After you have completed our seminar series, we will still be available for you if you need further support.',
  benefit_pat_1: 'TMJ problems can be solved with orthodontics in the majority of all cases',
  benefit_pat_2: 'Bite correction - cross bite, open bite, scissor bite, asymmetry, crowding, diastemas, impacted teeth',
  benefit_pat_3: 'Give your patients a beautiful smile',
  benefit_pat_4: 'Orthodontics can alleviate speech difficulties',
  benefit_pat_5: 'Orthodontics can reduce the risk of tooth trauma',

  // ############ TEAM SECTION #######################
  
  team_violeta_bio: "Seminar organization, on-site support for seminar participants, instructor for orthodontic assistance training. 20 years of work with patients and experience in orthodontics, and team management. Final diploma in CS Orthoseminars and CCO Orthodontic Course.",
  team_robert_bio: "Dr. Robert Scherngell, MSc has been practicing orthodontics for over 25 years. In addition to this, he has been teaching orthodontics globally for over 10 years. He has held seminars in Europe, Australia, Asia and the US. His comprehensive seminar series delivers profound education - for novices, advanced practitioners, and experienced orthodontists. Dr. Scherngell has successfully treated over 6000 cases in his two practices in Austria. He is a member of the Austrian Board of Orthodontists (ABO), and the European Orthodontic Society. He has a master's degree in orthodontics.  ABO exam in March 2009, Master of Orthodontics (Danube University Krems, Austria) March 2009. Member of the European Orthodontic Society, Verband Österreichischer Kieferorthopäden, Dental Medical Association Austria. Education Diploma in Dentistry of the Dental Medical Association, Austria.  Orthodontics of the Dental Medical Association, Austria",
  team_iva_bio: "Dr. Iva Ivanković",
  team_dalibor_bio: "He graduated from Dental School with distinction. He completed his training in dental prosthetics in Paris, after which he enrolled the Faculty of Dentistry at the University of Sarajevo. He was a member of the board of the Association of Dentists of FBiH. 12 years of successful practice in cooperation with specialists in all branches of dentistry. He is currently in his final year of specialization in orthodontics in Sarajevo. CS Orthoseminars finished in Zagreb with excellent results and since then he has been preparing to be a speaker at CS Orthoseminars.",
  team_guest_speaker: 'Guest speaker',
  team_seminar_speaker: 'Speaker',
  team_founder: 'Founder',
  team_seminar_organisator: 'Seminar organizer',
  our_team_member: 'Our team',
  meet_our_perfectionist: 'Meet our experts',
 
  // ############ FAQ SECTION #######################
  
  faq_title: 'Frequently Asked Questions (FAQ)',
  faq_subtitle: 'You have questions. We have answers.',

  // ############ CLIENT FEEDBACK #######################
  
  client_feedback_title: 'Feedback',
  client_feedback_subtitle: 'What our clients say about us',
  testimonial_suzana_designation: 'dentist, Split, Croatia',
  testimonial_suzana_comment: 'It was a great pleasure to attend CS Orthoseminars. Dr. Robert Scherngell’s program completely changed the way I think and for the first time I really feel I understand orthodontics!',
  testimonial_aida_designation: 'dentist, Sarajevo, Bosnia and Herzegovina',
  testimonial_aida_comment: 'CS Orthoseminar is an excellent series of seminars you can apply to your everyday practice. The lectures are intense and are carried out through modules which are designed to explain orthodontics in the best possible way. The CS Orthoseminars team selflessly share their knowledge and skills with you during the course of the seminar series.',
  testimonial_tamara_designation: 'dentist, Zagreb, Croatia',
  testimonial_tamara_comment: 'I completed a CS ortho program consisting of 9 modules. The modules are well structured and contain everything for a successful start in orthodontics. With the support of the CS team who are there for your every question I felt safer. Many thanks to the CS team for revealing the secrets of orthodontics and selflessly sharing their knowledge!',
  testimonial_eva_designation: 'dentist, Ljubljana, Slovenia',
  testimonial_eva_comment: 'Every day I look forward to my ortho patients and to the better life quality they experience through therapy. I recommend the CS Orthoseminars series to all colleagues who are interested, as I do their team who generously and systematically spread their knowledge. They answer all questions you may have during the course and also after so that no one is left to themselves in case of complications.',
  testimonial_matea_designation:'dentist, Rijeka, Croatia',
  testimonial_matea_comment: 'Besides the excellent organization and knowledge, I have gained, I am very grateful for the active engagement of the CS Ortho Team. Especially regarding the availability, there were always quick responses, also via mail, viber group or phone calls – and it doesn´t matter if during or after the seminar! Thanks for everything! I am very glad to have been a part of this whole Master trip.',
  testimonial_diana_designation: 'dentist, Glina, Croatia',
  testimonial_diana_comment: 'If you wish to improve your work and the work of your office, surely do so with the CS Orthoseminar team. Thankyou to Violeta and Dr. Scherngell for their knowledge and support.',
  testimonial_ante_designation: 'dentist, Split, Hrvatska',
  testimonial_ante_comment: 'CS Orthoseminars fulfilled all my expectations, through the seminars I gained the necessary knowledge and skills to successfully enter the world of orthodontics. The entire process is accompanied by extraordinary support, so orthodontic therapy conducted in this way is simply doomed to success.',
  testimonial_anica_plamenac_designation: 'dentist, Podgorica, Crna Gora',
  testimonial_anica_plamenac_comment: 'Seminars through modules summarize all the most important aspects of orthodontics. The CS Orthoseminars team selflessly shares their skills as well as support to solve all the cases we encounter in our practice. I highly recommend CS Orthoseminars to all my colleagues.',

  // ############ CLIENT FEEDBACK #######################
  
  registration_title: 'Register',
  registration_subtitle: 'Quick and simple',

  //########PERSON
  
  person_tos_checkbox: 'I accept the privacy policy and terms of use',
  person_additional_info: 'Additional information',
  person_country: 'Country',
  person_postal: 'Zip code',
  person_city: 'City',
  person_street_number: 'Number',
  person_street: 'Street',
  person_ordination: 'Office',
  person_phone: 'Phone',
  person_email: 'Email',
  person_last_name: 'Surname',
  person_first_name: 'Name',
  person_title: 'Title',
  seminar_register: 'Send',
  address: 'Address',
  
  // ############### PAYMENT REGISTRATION BLOCK
  
  payment_type_title: 'Payment type',
  payment_type_free: 'Free of charge',
  payment_total: 'Pay in full',
  payment_partial_down: 'Three-part payment plan (3 instalments)',
  payment_partial_modules: 'Nine-part payment plan (9 instalments)',
  required: 'Required field *',
  wrong_email: 'The email address you entered is incorrect!',
  payment_type_total_info: 'An early payment discount of 10% will be applied if the seminar fees are paid in full and no later than 14 days before the start of the course (Module 1).',
  payment_type_partial_down_info: 'If the 3 instalment payments option is chosen, a 5% discount will be applied on the course fee.',
  payment_type_partial_down_info_1: '1st instalment: 14 days before module 1 (at the latest) /',
  payment_type_partial_down_info_2: '2nd instalment: 14 days before module 3 (at the latest)  /',
  payment_type_partial_down_info_3: '3rd instalment: 14 days before module 5 (at the latest)  /',
  payment_type_partial_modules_info: ' If the 9 instalment payments option is chosen, the full price must be paid before each module (no discount).',
  payment_type_partial_modules_info_1: '1st,3rd,4th,5th,6th,7th,8th,9th instalments: 14 days before module (at the latest) /',
  payment_type_partial_modules_info_2: '2nd instalment (3 days): 14 days before module 2 (at the latest) /',
  
  // ############### SUBMIT INFO
  
  submit_error_happens: 'Error!!!',
  submit_try_again: 'Please try again or contact us.',
  submit_success_headline: 'Registration successfully submitted!',
  submit_success_subText: 'Confirmation of registration has been sent to your Email address. Thank you for your trust!',
  submit_ok: 'OK',

  cookies_text: 'This website uses "cookies" to improve the user experience. For more information read our ',
  cookies_privacy_policy: 'Privacy policy',
  
  // ###########################Seminar CONTENT
  
  info_seminar_content_heading: "“Orthodontics for beginners and advanced practitioners in 9 modules”",
  info_seminar_content_description: "Why should you learn with “Common Sense”? Common Sense Orthoseminars are based on Dr. Robert Scherngell's orthodontic experience, gained over 28 years of working in the field, with more than 6,000 successful orthodontic therapies. The seminar program contains practical elements, clear explanations, and is accompanied by numerous videos and animations.",

  banner_eight_discount: "10% discount",
  banner_single_payment: "on early payment",
  banner_register_sarajevo: "3000 KN discount until 24.07.2022",
  banner_orthodontic_seminars: "Orthodontic seminars",

  call_to_action_heading: "“Practical and logical through orthodontics”",
  call_to_action_alt_title: "“Practical and logical through orthodontics”",
  call_to_action_contact: "CONTACT US",

  email_seminar_price: "Price",
  email_seminar_title: "You have successfully registered for the seminar",
  email_additional_info: "Additional information",
  email_date: "Date",
  email_success: "Your registration was successful!",
  email_seminar_duration_per_day: "Seminar time daily 0930 hours - 1700 hours",
  email_seminar_tax_hr: 'including 25% VAT',
  email_seminar_tax_bih: 'including 17% VAT',

  go_to_sign_up: 'Sign up',
  sign_up_to_the_waiting_list: 'Sign up to the waiting list',
  included_in_the_price: 'Included in the price',
  price: "Price",
  choose_payment_type: "Choose payment method",

  obligatory_regisration_title: "Mandatory registration",
  waiting_list_registration_title: "Sign up to the waiting list for the next series",
  waiting_list_registration_title_email: "Sign up to the waiting list for the series after ",
})

export default messages
